import { ActionType } from 'typesafe-actions';
import { IUiStore } from '../type';
import * as actionKeys from './action-keys';
import * as actions from './actions';

const DEFAULT_STATE: IUiStore = {
    status: 'initializing',
    hasContentInsurance: null,
    currentStep: 1,
    resources: {
        errorHeader: 'Der opstod en fejl',
        errorTitle: 'Der opstod en fejl',
        errorDescription: 'Du kan prøve igen eller kontakte os hvis problemet forsætter.',
        errorBackText: 'Tilbage',
        errorContactLink: 'https://www.topdanmark.dk/faa-hjaelp/kontakt-os/',
        errorContactText: 'Kontakt os'
    },
    endpoints: {
        resources: '',
        contentBlocks: '',
        log: '',
        createOffer: {
            url: '',
            options: {}
        },
        updateOffer: {
            url: '',
            options: {}
        },
        submitOffer: {
            url: '',
            options: {}
        },
        getReceipt: {
            url: '',
            options: {}
        }
    },
    primaryType: 'accident',
    updatingCoverage: null
};

type UiAction = ActionType<typeof actions>;

export const uiReducer = (state: IUiStore = DEFAULT_STATE, action: UiAction): IUiStore => {
    switch (action.type) {
        case actionKeys.setHasContentInsurance:
            return {
                ...state,
                hasContentInsurance: action.payload.hasContentInsurance
            };

        case actionKeys.setResources:
            return {
                ...state,
                resources: action.payload
            };

        case actionKeys.setConfig:
            return {
                ...state,
                endpoints: action.payload.endpoints,
                primaryType: action.payload.primaryType
            };

        case actionKeys.setUiStatus:
            return {
                ...state,
                status: action.payload
            };

        case actionKeys.setFormStep:
            return {
                ...state,
                currentStep: action.payload
            };

        case actionKeys.setUpdatingCoverage:
            return {
                ...state,
                updatingCoverage: action.payload
            };

        case actionKeys.setDataPolicyContentBlock:
            return {
                ...state,
                dataPolicyContentBlock: action.payload
            };

        case actionKeys.setTerminationFeeContentBlock:
            return {
                ...state,
                terminationFeeContentBlock: action.payload
            };

        default:
            return state;
    }
};
